import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class TimelineFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled: boolean) {
        super(Features.Timeline, "MultiJurisdictionCms.Dto.Features.TimelineFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.TimelineFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}